import type { FC, ReactNode } from "react";

import { Card, CardRowSimple, type GridCard } from "widgets";

import { GeneTile } from "../../core/tiles/index.js";
import type { GeneMutation } from "@/graphql.ts";
import { SelMessage } from "@/messages/SelMessage.tsx";

export interface IGeneMutationsCardProps extends GridCard {
  geneMutations: GeneMutation[];
  ignoreIfEmpty?: boolean;
  title?: string;
  showSource?: boolean;
}

const GeneMutationsCard: FC<IGeneMutationsCardProps> = (props) => {
  const geneMutations: GeneMutation[] = props.geneMutations;
  if (props.ignoreIfEmpty && (!geneMutations || geneMutations.length === 0)) {
    return null;
  }

  let elements: ReactNode = <SelMessage id={"noContent.relatedGenes"} />;

  if (geneMutations && geneMutations.length > 0) {
    elements = geneMutations.map((geneMutation: GeneMutation) => {
      return (
        <GeneTile
          gene={geneMutation.gene}
          footNote={`${geneMutation.locationClass}, ${geneMutation.effect}`}
          key={`geneMutation-card-elem-${geneMutation.id}`}
        />
      );
    });
  }

  return (
    <Card
      shrinkable={props.geneMutations.length > 5}
      icon={"sticky_note_2"}
      title={props.title ?? "Reference Genes"}
      tag={{ label: String(geneMutations.length) }}
    >
      <CardRowSimple>{elements}</CardRowSimple>
    </Card>
  );
};

export default GeneMutationsCard;
export { GeneMutationsCard };
